import React, { useCallback } from 'react'

import type { IControlProps } from 'components/controls/Field/Field.types'
import type { IInputProps } from 'components/uiKit/Input'
import Input from 'components/uiKit/Input'

/** @deprecated use [FormKit](../../../../components/formKit/fields/index.ts) */
const FieldInput: React.FC<IControlProps<IInputProps>> = ({
  name,
  onChange,
  defaultValue,
  value,
  ...rest
}) => {
  const onChangeWrapper = useCallback(
    (value: string) => onChange({ name, value }),
    [name, onChange],
  )

  return (
    <Input
      {...rest}
      name={name}
      onChange={onChangeWrapper}
      value={value ?? (defaultValue as string)}
    />
  )
}

export default FieldInput
